export enum MapsInfoWindowEventType {
	OPEN,
	CLOSE,
}
